(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68],{

/***/ 4665:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/category/[uid]",
      function () {
        return __webpack_require__(8196);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CategoryTag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
;// CONCATENATED MODULE: ./components/CategoryTag/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj;
    return {
        CategoryTag: (_obj = {
            cursor: "pointer",
            borderRadius: 6,
            backgroundColor: "#f5faff",
            padding: theme.spacing(2),
            fontFamily: "Raleway,Assistant",
            fontSize: 16,
            fontWeight: 700,
            color: "#4c4c78",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            margin: theme.spacing(0),
            fontSize: 15
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            width: "100%",
            fontSize: 16
        }), _defineProperty(_obj, "&:hover", {
            backgroundColor: "#4a92cf",
            color: "#fff"
        }), _defineProperty(_obj, "& .activeTag", {
            backgroundColor: "#4a92cf",
            color: "#fff"
        }), _defineProperty(_obj, "& img", {
            marginLeft: theme.direction === "ltr" ? 0 : 8,
            marginRight: theme.direction === "ltr" ? 8 : 0,
            width: 14
        }), _obj)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/CategoryTag/index.js






var CategoryTag = function(param) {
    var classes = param.classes, CategoryTagIconSrc = param.CategoryTagIconSrc, CategoryTagIconAlt = param.CategoryTagIconAlt, CategoryTagTitle = param.CategoryTagTitle, showIcon = param.showIcon, selected = param.selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.CategoryTag,
        children: [
            showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: CategoryTagIconSrc,
                alt: CategoryTagIconAlt
            }),
            CategoryTagTitle
        ]
    });
};
CategoryTag.defaultProps = {
    showIcon: false
};
CategoryTag.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    CategoryTagIconSrc: (prop_types_default()).string,
    CategoryTagIconAlt: (prop_types_default()).string,
    CategoryTagTitle: (prop_types_default()).string,
    showIcon: (prop_types_default()).bool
};
/* harmony default export */ var components_CategoryTag = ((0,withStyles/* default */.Z)(style)(CategoryTag));


/***/ }),

/***/ 4394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







var Head = function(param) {
    var data = param.data, canonical = param.canonical;
    var siteUrl = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])().publicRuntimeConfig.siteUrl;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var canonicalUrl = canonical === "/homepage" ? "".concat(siteUrl, "/").concat(router.locale) : "".concat(siteUrl, "/").concat(router.locale).concat(canonical);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#d6a560"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#ffffff"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            !data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "VFI"
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.meta_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_title)
            }),
            data.meta_description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: prismic_reactjs__WEBPACK_IMPORTED_MODULE_4__.RichText.asText(data.meta_description)
            }),
            data.og_image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: data.og_image.url
            }),
            data.robots_index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: data.robots_index ? "all" : "noindex"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            })
        ]
    });
};
Head.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_2___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_2___default().any))
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TitleSubtitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
;// CONCATENATED MODULE: ./components/TitleSubtitle/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        whiteTxt: {
            "& .title": {
                color: "#fff",
                textTransform: "uppercase",
                textAlign: "center"
            },
            "& .subtitle": (_obj1 = {
                color: "#fff",
                textAlign: "center",
                fontWeight: 700,
                marginTop: theme.spacing(3),
                letterSpacing: 1.1,
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj1, "& p", (_obj = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj, "& strong", {
                fontWeight: 900
            }), _obj)), _obj1)
        },
        blueTxt: {
            "& .title": {
                color: "#4c4c78",
                textTransform: "uppercase",
                textAlign: "center"
            },
            "& .subtitle": (_obj3 = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj3, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj3, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj3, "& p", (_obj2 = {
                color: "#4c4c78",
                textAlign: "center",
                letterSpacing: 1.1,
                fontWeight: 700,
                marginTop: theme.spacing(3),
                fontSize: 18,
                lineHeight: 1.5
            }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
                marginTop: theme.spacing(2),
                fontSize: 17
            }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
                marginTop: theme.spacing(1),
                fontSize: 16
            }), _defineProperty(_obj2, "& strong", {
                fontWeight: 900
            }), _obj2)), _obj3)
        }
    };
};
/* harmony default export */ var style = (styles);

;// CONCATENATED MODULE: ./components/TitleSubtitle/index.js







var TitleSubtitle = function(param) {
    var classes = param.classes, title = param.title, subtitle = param.subtitle, showClass = param.showClass;
    subtitle = subtitle || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        className: showClass ? classes.whiteTxt : classes.blueTxt,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            item: true,
            xs: 12,
            container: true,
            alignItems: "center",
            justify: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h1",
                    component: "h2",
                    className: "title",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "subtitle",
                    children: subtitle
                })
            ]
        })
    });
};
TitleSubtitle.defaultProps = {
    showClass: false
};
TitleSubtitle.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    title: (prop_types_default()).string,
    subtitle: (prop_types_default()).any,
    showClass: (prop_types_default()).bool
};
/* harmony default export */ var components_TitleSubtitle = ((0,withStyles/* default */.Z)(style)(TitleSubtitle));


/***/ }),

/***/ 3438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_WorkItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./utils/prop-types.js
var utils_prop_types = __webpack_require__(9725);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(5154);
;// CONCATENATED MODULE: ./components/WorkItem/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var style = function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        workItem: {
            boxShadow: "0 22px 57px 0 rgba(79, 89, 138, 0.16)",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "& img": {
                width: "100%",
                height: 273,
                objectFit: "cover",
                verticalAlign: "bottom"
            },
            "& a": {
                textDecoration: "none"
            },
            "& .featureWorkItemData": (_obj2 = {
                padding: theme.spacing(4),
                display: "flex",
                flexDirection: "column",
                height: "100%"
            }, _defineProperty(_obj2, theme.breakpoints.down("sm"), {
                padding: theme.spacing(4)
            }), _defineProperty(_obj2, theme.breakpoints.down("xs"), {
                padding: theme.spacing(2),
                height: "unset"
            }), _defineProperty(_obj2, "& .featuredInfo", {
                flex: 1,
                "& .featuredProjectTitle": (_obj = {
                    fontFamily: "Raleway,Assistant",
                    fontSize: 21,
                    color: "#4c4c78",
                    marginBottom: theme.spacing(1),
                    fontWeight: 700
                }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
                    fontSize: 20
                }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
                    fontSize: 19
                }), _obj),
                "& .projectCategoryTitle": (_obj1 = {
                    fontFamily: "Raleway,Assistant",
                    fontSize: 18,
                    color: "#4c4c78"
                }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
                    fontSize: 17
                }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
                    fontSize: 16
                }), _obj1)
            }), _obj2),
            "& .button": {
                marginTop: theme.spacing(2)
            }
        }
    });
};
/* harmony default export */ var WorkItem_style = (style);

// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
;// CONCATENATED MODULE: ./components/WorkItem/index.js










function WorkItem(param) {
    var classes = param.classes, work = param.work;
    var data = work.data;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
        link: work,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.workItem,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: data.featured_image.url,
                    alt: data.featured_image.alt
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "featureWorkItemData",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "featuredInfo",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "featuredProjectTitle",
                                    children: prismic_reactjs.RichText.asText(data.title)
                                }),
                                data.project_category && data.project_category.data && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "projectCategoryTitle",
                                    children: prismic_reactjs.RichText.asText(data.project_category.data.title)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: work,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "button",
                                variant: "outlined",
                                color: "primary",
                                fullWidth: true,
                                children: prismic_reactjs.RichText.asText(layout.project_learn_more_button_text)
                            })
                        })
                    ]
                })
            ]
        })
    });
}
WorkItem.propTypes = {
    work: prop_types_default().shape({
        title: utils_prop_types/* structuredTextPropTypes */.h,
        featuredImage: utils_prop_types/* imagePropTypes */.R,
        projectCategory: prop_types_default().objectOf((prop_types_default()).any)
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var components_WorkItem = ((0,withStyles/* default */.Z)(WorkItem_style)(WorkItem));


/***/ }),

/***/ 8196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _uid_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(3832);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
;// CONCATENATED MODULE: ./components/Projects/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1;
    return {
        Projects: (_obj1 = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _defineProperty(_obj1, "& .CategoryTagWrapper", (_obj = {
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10)
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9)
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _obj)), _obj1)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./components/WorkItem/index.js + 1 modules
var WorkItem = __webpack_require__(3438);
// EXTERNAL MODULE: ./components/CategoryTag/index.js + 1 modules
var CategoryTag = __webpack_require__(1130);
// EXTERNAL MODULE: ./components/TitleSubtitle/index.js + 1 modules
var TitleSubtitle = __webpack_require__(8785);
// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
;// CONCATENATED MODULE: ./components/Projects/index.js













var Projects = function(param) {
    var title = param.title, subtitle = param.subtitle, categories = param.categories, projects = param.projects, viewAllCategory = param.viewAllCategory, classes = param.classes, params = param.params;
    var ref = (0,react.useState)(projects.next_page), nextPage = ref[0], setNextPage = ref[1];
    var ref1 = (0,react.useState)(projects.results), results = ref1[0], setResults = ref1[1];
    (0,react.useEffect)(function() {
        setResults(projects.results);
    }, [
        projects
    ]);
    // useEffect(() => {
    //   fetch(`${nextPage}`)
    //     .then((response) => response.json())
    //     .then((data) => {
    //       setResults(results.concat(data.results));
    //       setNextPage(data.next_page);
    //     });
    // }, [nextPage]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "lg",
        className: classes.Projects,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                title: title,
                subtitle: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 2,
                direction: "row",
                justify: "center",
                alignItems: "center",
                className: "CategoryTagWrapper",
                children: [
                    viewAllCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                            link: {
                                type: "page",
                                uid: "projects"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                    selected: true,
                                    CategoryTagIconSrc: "/viewAll.svg",
                                    CategoryTagIconAlt: "View All",
                                    CategoryTagTitle: "View All",
                                    showIcon: true
                                })
                            })
                        })
                    }),
                    categories.results.map(function(category, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: category,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTag/* default */.Z, {
                                    selected: category.uid == params.uid,
                                    CategoryTagIconSrc: category.data.icon.url,
                                    CategoryTagIconAlt: category.data.icon.alt,
                                    CategoryTagTitle: prismic_reactjs.RichText.asText(category.data.title),
                                    showIcon: true
                                })
                            })
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 4,
                direction: "row",
                justify: "center",
                children: results && results.map(function(project, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkItem/* default */.Z, {
                            work: project
                        })
                    }, index);
                })
            })
        ]
    });
};
Projects.defaultProps = {
    viewAllCategory: false
};
Projects.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    title: (prop_types_default()).string,
    subtitle: (prop_types_default()).string,
    projects: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    categories: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    viewAllCategory: (prop_types_default()).bool
};
/* harmony default export */ var components_Projects = ((0,withStyles/* default */.Z)(style)(Projects));

// EXTERNAL MODULE: ./components/Head/index.js
var Head = __webpack_require__(4394);
;// CONCATENATED MODULE: ./pages/projects/category/[uid].js







var ProjectCategory = function(props) {
    var currentCategory = props.currentCategory, categories = props.categories, allProjectsBasedOnCategory = props.allProjectsBasedOnCategory, params = props.params;
    var setHeaderColor = (0,layout_context/* useLayout */.$Y)().setHeaderColor;
    (0,react.useEffect)(function() {
        setHeaderColor(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                data: currentCategory.data,
                canonical: "/projects/category/".concat(params.uid)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: currentCategory && allProjectsBasedOnCategory && categories && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Projects, {
                    params: params,
                    title: prismic_reactjs.RichText.asText(currentCategory.data.title),
                    subtitle: prismic_reactjs.RichText.asText(currentCategory.data.subtitle),
                    projects: allProjectsBasedOnCategory,
                    categories: categories,
                    viewAllCategory: true
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _uid_ = (ProjectCategory);


/***/ }),

/***/ 9725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ imagePropTypes; },
/* harmony export */   "h": function() { return /* binding */ structuredTextPropTypes; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

var structuredTextPropTypes = prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    type: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    text: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    spans: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().array)
}));
var imagePropTypes = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    dimensions: prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
        width: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),
        height: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number)
    }),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    copyright: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    url: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(4665); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);